/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Birthday_Self_SharedInputs */

const fr_calendar_birthday_self_shared = /** @type {(inputs: Calendar_Birthday_Self_SharedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· tu le fêtes avec`)
};

/**

* @param {Calendar_Birthday_Self_SharedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_birthday_self_shared = /** @type {((inputs?: Calendar_Birthday_Self_SharedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Birthday_Self_SharedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_birthday_self_shared(inputs)
});